import React, { useEffect, useState, useRef } from "react"
import "./styles.scss"

import { Swiper, SwiperSlide } from "swiper/react"

import SwiperCore, { EffectFade, Pagination } from "swiper"

import "swiper/swiper.scss"
import "swiper/components/effect-fade/effect-fade.scss"
SwiperCore.use([EffectFade, Pagination])

const TabsVertical = ({ tabs }) => {
  const itemEls = useRef([])

  const [isDesktop, setIsDesktop] = useState(true)

  const [activeTab, setActiveTab] = useState(0)
  const [tabHeight, setTabHeight] = useState(null)

  let tabsHeight = ""
  const handleTab = tab => {
    setActiveTab(tab)
  }

  function checkDevice() {
    if (window.innerWidth > 1000) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  }

  useEffect(() => {
    checkDevice()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", checkDevice)
    return () => {
      window.removeEventListener("resize", checkDevice)
    }
  })

  useEffect(() => {
    let tabs = itemEls.current
    tabs.forEach(tab => {
      if (tab && tab.clientHeight > tabsHeight) {
        tabsHeight = tab.clientHeight
      }
    })
    setTabHeight(tabsHeight)
  }, [itemEls])

  if (isDesktop) {
    return (
      <div className="tabsVertical">
        <ul className="tabsVertical__navigation">
          {tabs.map((tab, i) => {
            return (
              <li
                data-content={tab.title}
                onClick={() => {
                  handleTab(i)
                }}
                key={i}
                className={`tab ${i !== activeTab ? "" : "active"}`}
              >
                {tab.title}
              </li>
            )
          })}
        </ul>
        <div className="tabsVertical__content">
          {tabs.map((tab, i) => {
            return (
              <div
                ref={element => itemEls.current.push(element)}
                style={{ minHeight: tabHeight }}
                key={i}
                className={` ${i !== activeTab ? "" : "active"}`}
              >
                <p>{tab.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    )
  } else {
    return (
      <div className="tabsVerticalMobile">
        <ul className="tabsVerticalMobile__navigation">
          {tabs.map((tab, i) => {
            return <li key={i}>{i + 1}</li>
          })}
        </ul>
        <Swiper
          pagination={{
            el: ".tabsVerticalMobile__navigation",
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<span class="' + className + '">' + (index + 1) + "</span>"
              )
            },
          }}
          speed="1000"
          effect="fade"
        >
          {tabs.map((tab, i) => {
            return (
              <SwiperSlide key={i}>
                <h5>{tab.title}</h5>
                <p>{tab.description}</p>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    )
  }
}
export default TabsVertical
